import { Trash2, X } from 'lucide-react'
import { Button } from '@/components/ui/button'

/**
 * Sticky bottom toolbar that appears whenever any row in a list is selected.
 * Used on the seeds Dashboard, the SharesPage, and (where applicable) the
 * SeedDetail Versions tab — though the Versions tab also has its own
 * "Prune…" dialog with finer-grained controls.
 */

export interface BulkSelectToolbarProps {
  count: number
  itemLabel: string // e.g. "seed" or "share" — pluralized client-side
  onClear: () => void
  onDelete: () => void
  deleting?: boolean
}

export function BulkSelectToolbar({ count, itemLabel, onClear, onDelete, deleting }: BulkSelectToolbarProps) {
  if (count === 0) return null
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 rounded-full border bg-background shadow-lg px-3 py-1.5">
      <span className="text-sm">
        <strong>{count}</strong> {itemLabel}{count === 1 ? '' : 's'} selected
      </span>
      <Button variant="ghost" size="sm" className="h-7 w-7 p-0" onClick={onClear} title="Clear selection">
        <X className="h-3.5 w-3.5" />
      </Button>
      <Button variant="destructive" size="sm" className="h-7" onClick={onDelete} disabled={deleting}>
        <Trash2 className="h-3.5 w-3.5 mr-1" />
        Delete
      </Button>
    </div>
  )
}
